import { Flag, Phone } from "lucide-react";
import { CONTACTS, ADDRESS } from "@/data/site";

export default function Footer() {
  return (
    <footer className="relative bg-carbon border-t border-steel" data-testid="footer">
      <div className="h-1.5 hazard-stripes" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 border border-steel bg-card flex items-center justify-center">
                <Flag className="w-5 h-5 text-hazard" />
              </span>
              <p className="font-heading font-black uppercase text-3xl tracking-tight" data-testid="footer-brand-title">
                <span className="text-racing">GSX</span> <span className="chrome-text">Diesel</span>{" "}
                <span className="text-white/60 text-xl">Truck Repair LLC</span>
              </p>
            </div>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-widest text-slate-500">
              Licensed & Insured Heavy-Duty Mechanical & Towing Service Provider
            </p>
            <p className="mt-2 text-sm text-slate-400">{ADDRESS}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            {[CONTACTS.omar, CONTACTS.ray].map((c) => (
              <a
                key={c.name}
                href={c.tel}
                data-testid={`footer-call-${c.name.toLowerCase()}`}
                className="flex items-center gap-3 px-5 py-3 border border-steel text-slate-300 hover:border-hazard hover:text-hazard transition-colors duration-300"
              >
                <Phone className="w-4 h-4" />
                <span className="font-heading font-bold uppercase">{c.name} {c.phone}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-steel flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">
            © 2026 GSX Diesel Truck Repair LLC. All Rights Reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">
            Bloomington, CA — Inland Empire
          </p>
        </div>
      </div>
    </footer>
  );
}
